import i18n from "i18next"
import {initReactI18next} from "react-i18next"
import CommonService from './services/common.service'
import LanguageDetector from 'i18next-browser-languagedetector'
import resources from './translation.json'
import {AVAILABLE_LANGUAGES} from "./constants";

const DETECTION_OPTIONS = {
    order: ['localStorage']
}

i18n
    .use(initReactI18next)
    .use(LanguageDetector)
    .init({
        detection: DETECTION_OPTIONS,
        resources: resources,
        lng: CommonService.getLang(),
        fallbackLng: CommonService.getLang(),
        supportedLangs: AVAILABLE_LANGUAGES,
        interpolation: {
            escapeValue: false
        }
    })

export default i18n
